<div class="modal-body" ngbAutofocus>
  @if (isModal) {
    <fa-icon icon="times-circle" class="top-right-close-btn" (click)="close()"></fa-icon>
  }
  <myp-inline-loader
    [loading]="checkoutService.loadingCheckout"
    [spinnerMessage]="checkoutService.loadingMsg ? checkoutService.loadingMsg : false"
    height="200px"
    spinnerName="paymentFieldsLoader"
  ></myp-inline-loader>
  @if (checkoutService.loadingMsg) {
    @if (checkoutService.loadingCheckout) {
      <div class="text-center d-flex justify-content-center m-y-20">
        <round-progress
          [current]="checkoutService.percentDone"
          [max]="100"
          [color]="'#45ccce'"
          [background]="'#eaeaea'"
          [radius]="125"
          [stroke]="20"
          [semicircle]="false"
          [rounded]="true"
          [clockwise]="true"
          [responsive]="false"
          [duration]="250"
          [animation]="'easeInOutQuart'"
          [animationDelay]="0"
        ></round-progress>
      </div>
    }
  }
  <div class="modal-purchase-container">
    <div class="modal-purchase" [ngStyle]="{ opacity: checkoutService.loadingCheckout ? '0' : '1', height: checkoutService.loadingCheckout ? '1px' : 'auto', overflow: 'hidden' }">
      <div>
        <myp-checkout-product-details [productDetails]="checkoutService.selectedProduct" [defaultImage]="productInfo.image"></myp-checkout-product-details>
      </div>
      @if (showConfirmStep && !purchaseConfirmed) {
        <div class="confirm-purchase">
          @if (checkoutService.genericProduct) {
            <h3 class="brandfont-black">{{ checkoutService.genericProduct.title }}</h3>
            @if (checkoutService.selectedActiveOffer) {
              <div class="m-b-20">
                @if (checkoutService.selectedActiveOffer) {
                  <h2 class="brandfont-black d-block c-link-blue">{{ checkoutService.selectedActiveOffer.display_message }}</h2>
                }
              </div>
            }
            @switch (productInfo.stringId) {
              @case ("studioapp6.artist") {
                <ng-container [ngTemplateOutlet]="studioApp6Artist"></ng-container>
              }
              @case ("studioapp6.pro") {
                <ng-container [ngTemplateOutlet]="studioApp6Pro"></ng-container>
              }
              @case ("studioapp7.pro") {
                <ng-container [ngTemplateOutlet]="studioApp7Pro"></ng-container>
              }
            }
          }
        </div>
      }
      @if (!showConfirmStep || purchaseConfirmed) {
        <div class="order-form animate-in-down">
          @if (checkoutInitted) {
            <myp-stripe-payment
              #stripePaymentCmp
              [showPaymentForm]="checkoutService.selectedProductUpgrade && !checkoutService.loadingCheckout && checkoutService.selectedProduct"
              [showCouponButton]="checkoutService.selectedProductUpgrade && !checkoutService.loadingCheckout && checkoutService.selectedProduct"
              [showConfirmStep]="showConfirmStep"
            ></myp-stripe-payment>
          }
          @if (!isProductUpgraded && !checkoutService.loadingCheckout && (!showConfirmStep || purchaseConfirmed)) {
            <div class="container-fluid">
              <div class="row">
                <div class="buy-button-container col-12">
                  <span class="secure-transaction-badge m-r-20">
                    <fa-icon icon="lock"></fa-icon>
                    {{ "product_detail.secure_transaction" | translate }}
                  </span>
                  <button
                    type="button"
                    class="btn btn-primary"
                    [class.disabled]="
                      !checkoutService.isValidCheckout ||
                      checkoutService.loadingPrices ||
                      checkoutService.loadingCheckout ||
                      checkoutService.calculatingTax ||
                      checkoutService.applyingCoupon ||
                      checkoutService.total == 0
                    "
                    [disabled]="
                      !checkoutService.isValidCheckout ||
                      checkoutService.loadingPrices ||
                      checkoutService.loadingCheckout ||
                      checkoutService.calculatingTax ||
                      checkoutService.applyingCoupon ||
                      checkoutService.total == 0
                    "
                    (click)="checkoutService.checkOut()"
                  >
                    @if (loadingPrices || checkoutService.calculatingTax) {
                      <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
                    }
                    {{ (checkoutService.selectedProduct?.title?.indexOf("Upgrade from") > -1 ? "product_detail.upgrade.upgrade" : "product_detail.complete_purchase") | translate }}
                  </button>
                  <span class="mobile-total">Total: {{ checkoutService.total | currency: checkoutService.activeCurrency?.toUpperCase() }}</span>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

<ng-template #studioApp7Pro>
  @if (selectedActiveOffer) {
    <h2 class="brandfont-black d-block c-link-blue">{{ selectedActiveOffer.display_message }}</h2>
  }
  @if (alreadyOwnNotice) {
    <div class="m-b-10 t-12">
      {{ alreadyOwnNotice }}
      <br />
      <span class="link" [routerLink]="['products/detail/', env.product_ids.s17pro]" (click)="close()">
        {{ "general.view_product" | translate }}
        <fa-icon icon="chevron-right"></fa-icon>
      </span>
    </div>
  }
  <div class="brandfont m-b-20">
    {{ "product_detail.product_description" | translate }}
  </div>
  <div class="feature-column-container">
    <div class="feature-column m-r-20">
      <span class="brandfont-bold d-block m-b-10">{{ "product_detail.studio_one_pro_features" | translate }}</span>
      <ul class="m-t-20" style="padding-left: 15px; margin-top: 0px">
        <li>{{ "product_detail.unlimited_tracks" | translate }}</li>
        <li>{{ "product_detail.immersive_audio" | translate }}</li>
        <li>{{ "product_detail.lyrics_track" | translate }}</li>
        <li>{{ "product_detail.video_track" | translate }}</li>
        <li>{{ "product_detail.chord_track" | translate }}</li>
        <li>{{ "product_detail.scratch_pads" | translate }}</li>
        <li>{{ "product_detail.composition_tools" | translate }}</li>
        <li>{{ "product_detail.mastering_suite" | translate }}</li>
        <li>{{ "product_detail.live_performance" | translate }}</li>
        <li>{{ "product_detail.studio_one_remote" | translate }}</li>
      </ul>
    </div>
    <div class="feature-column m-r-20">
      <span class="brandfont-bold d-block m-b-10">{{ "product_detail.included_extras" | translate }}</span>
      <ul class="m-t-20" style="padding-left: 15px; margin-top: 0px">
        <li>{{ "product_detail.native_effects_plugins" | translate }}</li>
        <li>{{ "product_detail.celemony_melodyne" | translate }}</li>
        <li>{{ "product_detail.presence_xt" | translate }}</li>
        <li>{{ "product_detail.acoustic_drum_kits" | translate }}</li>
        <li>{{ "product_detail.producer_loops" | translate }}</li>
        <li>{{ "product_detail.electronic_audioloops" | translate }}</li>
        <li>{{ "product_detail.electronic_kits" | translate }}</li>
        <li>{{ "product_detail.studio_one_impulse_responses" | translate }}</li>
        <li>{{ "product_detail.third_party_sampler_support" | translate }}</li>
      </ul>
    </div>
  </div>
  @if (checkoutService.checkoutError && checkoutService.checkoutError.type == "coupon_error") {
    <div class="onboard-error m-y-20 t-18">
      <fa-icon icon="times-circle" class="pointer" (click)="checkoutService.checkoutError = undefined"></fa-icon>
      {{ checkoutService.checkoutError.message }}
    </div>
  }
  <br />
  <div class="buy-button-container">
    <span class="secure-transaction-badge m-r-20">
      <fa-icon icon="lock"></fa-icon>
      {{ "product_detail.secure_transaction" | translate }}
    </span>
    <span class="btn btn-primary m-r-10" (click)="confirmPurchase()">
      {{ "product_detail.buy_now" | translate }}
      @if (checkoutService.total > 0) {
        <span [innerHTML]="checkoutService.total | currency: checkoutService.activeCurrency?.toUpperCase()"></span>
      }
    </span>
    <span class="mobile-total">{{ "product_detail.total" | translate: { amount: checkoutService.total | currency: checkoutService.activeCurrency?.toUpperCase() } }}</span>
  </div>
</ng-template>

<ng-template #studioApp6Pro>
  @if (selectedActiveOffer) {
    <h2 class="brandfont-black d-block c-link-blue">{{ selectedActiveOffer.display_message }}</h2>
  }
  @if (alreadyOwnNotice) {
    <div class="m-b-10 t-12">
      {{ alreadyOwnNotice }}
      <br />
      <span class="link" [routerLink]="['products/detail/', env.product_ids.s16pro]" (click)="close()">
        {{ "general.view_product" | translate }}
        <fa-icon icon="chevron-right"></fa-icon>
      </span>
    </div>
  }
  <div class="brandfont m-b-20">
    {{ "product_detail.studio_6_description" | translate }}
  </div>
  <div class="feature-column-container">
    <div class="feature-column m-r-20">
      <span class="brandfont-bold d-block m-b-10">{{ "product_detail.version_6_pro_features" | translate }}</span>
      <ul class="m-t-20" style="padding-left: 15px; margin-top: 0px">
        <li>{{ "product_detail.unlimited_tracks" | translate }}</li>
        <li>{{ "product_detail.immersive_audio" | translate }}</li>
        <li>{{ "product_detail.lyrics_track" | translate }}</li>
        <li>{{ "product_detail.video_track" | translate }}</li>
        <li>{{ "product_detail.chord_track" | translate }}</li>
        <li>{{ "product_detail.scratch_pads" | translate }}</li>
        <li>{{ "product_detail.composition_tools" | translate }}</li>
        <li>{{ "product_detail.mastering_suite" | translate }}</li>
        <li>{{ "product_detail.live_performance" | translate }}</li>
        <li>{{ "product_detail.studio_one_remote" | translate }}</li>
      </ul>
    </div>
    <div class="feature-column m-r-20">
      <span class="brandfont-bold d-block m-b-10">{{ "product_detail.included_extras" | translate }}</span>
      <ul class="m-t-20" style="padding-left: 15px; margin-top: 0px">
        <li>{{ "product_detail.native_effects_plugins" | translate }}</li>
        <li>{{ "product_detail.celemony_melodyne" | translate }}</li>
        <li>{{ "product_detail.presence_xt" | translate }}</li>
        <li>{{ "product_detail.acoustic_drum_kits" | translate }}</li>
        <li>{{ "product_detail.producer_loops" | translate }}</li>
        <li>{{ "product_detail.electronic_audioloops" | translate }}</li>
        <li>{{ "product_detail.electronic_kits" | translate }}</li>
        <li>{{ "product_detail.studio_one_impulse_responses" | translate }}</li>
        <li>{{ "product_detail.third_party_sampler_support" | translate }}</li>
      </ul>
    </div>
  </div>
  @if (checkoutService.checkoutError && checkoutService.checkoutError.type == "coupon_error") {
    <div class="onboard-error m-y-20 t-18">
      <fa-icon icon="times-circle" class="pointer" (click)="checkoutService.checkoutError = undefined"></fa-icon>
      {{ checkoutService.checkoutError.message }}
    </div>
  }
  <br />
  <div class="buy-button-container">
    <span class="secure-transaction-badge m-r-20">
      <fa-icon icon="lock"></fa-icon>
      {{ "product_detail.secure_transaction" | translate }}
    </span>
    <span class="btn btn-primary m-r-10" (click)="confirmPurchase()">
      {{ "product_detail.buy_now" | translate }}
      @if (checkoutService.total > 0) {
        <span [innerHTML]="checkoutService.total | currency: checkoutService.activeCurrency?.toUpperCase()"></span>
      }
    </span>
    <span class="mobile-total">Total: {{ checkoutService.total | currency: checkoutService.activeCurrency?.toUpperCase() }}</span>
  </div>
</ng-template>

<ng-template #studioApp6Artist>
  @if (selectedActiveOffer) {
    <h2 class="brandfont-black d-block c-link-blue">{{ selectedActiveOffer.display_message }}</h2>
  }
  <div class="brandfont m-b-20">
    <p>
      {{ "product_detail.version_6_artist_description" | translate }}
    </p>
    <p>{{ "product_detail.version_6_artist_notice" | translate: { brandName: env.studioOnePlusBrandName } }}</p>
  </div>
  <div class="feature-column-container">
    <div class="feature-column m-r-20">
      <span class="brandfont-bold d-block m-b-10">{{ "product_detail.version_6_artist_features" | translate }}</span>
      <ul class="m-t-20" style="padding-left: 15px; margin-top: 0px">
        <li>{{ "product_detail.unlimited_tracks" | translate }}</li>
        <li>{{ "product_detail.version_6_native_effects_plugins" | translate }}</li>
        <li>{{ "product_detail.version_6_virtual_instruments" | translate }}</li>
        <li>{{ "product_detail.version_6_sample_libraries" | translate }}</li>
        <li>{{ "product_detail.version_6_celemony_melodyne" | translate }}</li>
      </ul>
    </div>
    <div class="feature-column m-r-20">
      <span class="brandfont-bold d-block">{{ env.studioOnePlusBrandName }} Features:</span>
      <span class="d-block m-b-10 font-italic">
        <fa-icon icon="exclamation-circle"></fa-icon>
        {{ "product_detail.version_6_not_included" | translate }}
      </span>
      <ul class="m-t-20" style="padding-left: 15px; margin-top: 0px">
        <li>{{ "newdash.feat_s1_pro" | translate }}</li>
        <li>{{ "newdash.feat_notion" | translate }}</li>
        <li>{{ "product_detail.version_6_all_plugins" | translate }}</li>
        <li>{{ "product_detail.version_6_all_add_ons" | translate }}</li>
        <li>{{ "product_detail.version_6_notion_add_ons" | translate }}</li>
        <li>{{ "product_detail.version_6_notion_add_ons_description" | translate }}</li>
        <li>{{ "product_detail.version_6_notion_collaboration_workspaces" | translate }}</li>
        <li>{{ "product_detail.brand_name_community" | translate: { brandName: env.studioOnePlusBrandName } }}</li>
        <li>{{ "product_detail.video_courses_and_lessons" | translate }}</li>
        <li>{{ "product_detail.exclusive_live_streams" | translate }}</li>
        <li>{{ "product_detail.exclusive_artist_exchange_content" | translate }}</li>
        <li>{{ "product_detail.100gb_cloud_storage" | translate }}</li>
        <li>{{ "product_detail.exclusive_studio_one_integrations" | translate }}</li>
      </ul>
    </div>
  </div>
  @if (checkoutService.checkoutError && checkoutService.checkoutError.type == "coupon_error") {
    <div class="onboard-error m-y-20 t-18">
      <fa-icon icon="times-circle" class="pointer" (click)="checkoutService.checkoutError = undefined"></fa-icon>
      {{ checkoutService.checkoutError.message }}
    </div>
  }
  <br />
  <div class="buy-button-container">
    <span class="secure-transaction-badge m-r-20">
      <fa-icon icon="lock"></fa-icon>
      {{ "product_detail.secure_transaction" | translate }}
    </span>
    <span class="btn btn-primary m-r-10" (click)="confirmPurchase()">
      {{ "product_detail.buy_now" | translate }}
      @if (checkoutService.total > 0) {
        <span [innerHTML]="checkoutService.total | currency: checkoutService.activeCurrency?.toUpperCase()"></span>
      }
    </span>
    <span>or&nbsp;&nbsp;&nbsp;</span>
    <span class="btn btn-primary m-r-10" (click)="getS1Plus()">
      Get {{ env.studioOnePlusBrandName }}
      <!-- <span *ngIf="checkoutService.total > 0" [innerHTML]="checkoutService.total | currency: checkoutService.activeCurrency?.toUpperCase()"></span> -->
    </span>
    <span class="mobile-total">Total: {{ checkoutService.total | currency: checkoutService.activeCurrency?.toUpperCase() }}</span>
  </div>
</ng-template>
